"use client"

import "@/styles/breadcrumb.scss"
import { useSearchParams } from "next/navigation"

const Breadcrumb = () => {
    const searchParams = useSearchParams()
    const mode = searchParams.get("mode")
    return (
        <div className="breadcrumb">
            <ul>
                <li className={mode == null ? "top item current" : "top item"}>
                    TOP
                </li>
                <li className={mode == "input" ? "item current" : "item"}>
                    アンケート回答
                </li>
                <li className={mode == "confirm" ? "item current" : "item"}>
                    回答内容確認
                </li>
                <li
                    className={
                        mode == "submit" ? "completion current" : "completion"
                    }
                >
                    完了
                </li>
            </ul>
        </div>
    )
}
export default Breadcrumb
